export const chartColors = {
  firstColor: 'rgba(54, 162, 235, 0.2)',
  secondColor: 'rgba(80, 80, 80, 0.2)',
  thirdColor: 'rgba(255, 206, 86, 0.2)',
  firstBorderColor: 'rgba(54, 162, 235, 1)',
  secondBorderColor: 'rgba(50, 50, 50, 0.5)',
  thirdBorderColor: 'rgba(255, 206, 86, 1)',
};

export const getAverageByLabel = (feedbackQuestions, allLabels) =>
  allLabels.map((label) => {
    const questionsOfType = feedbackQuestions.filter((q) => q.type === label);
    if (questionsOfType.length === 0) return null;

    let totalPoints = 0;
    let totalAnswers = 0;

    questionsOfType.forEach((item) => {
      const answers = item.surveyAnswers || [];
      totalPoints += answers.reduce((sum, answer) => sum + answer.point, 0);
      totalAnswers += answers.length;
    });

    if (totalAnswers === 0) return null;

    const avg = totalPoints / totalAnswers;
    return avg;
  });

export const hasAnyAnswer = (feedbackGroups) =>
  feedbackGroups?.some((group) =>
    group.feedbackQuestions.some((question) => {
      const answers = question.surveyAnswers || [];
      return answers.length > 0;
    })
  );
